import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

const getCompanionsState = (state: RootState) => state.companions;

export const selectCompanions = createSelector(
  [getCompanionsState],
  (companions) => companions.companions.data
);

export const selectCompanionsForChatDrawer = createSelector(
  [getCompanionsState],
  (companions) => companions.chatDrawerCompanions.data
);

export const selectCompanionsContinuationToken = createSelector(
  [getCompanionsState],
  (companions) => companions.companions.xMsContinuationToken
);

export const selectFilteredCompanions = (roomId: string) =>
  createSelector([getCompanionsState], (companions) =>
    companions.companions.data.filter((profile) =>
      profile.rooms.find((room) => room.roomId === roomId)
    )
  );

export const selectLoadingCompanions = createSelector(
  [getCompanionsState],
  (companions) => companions.loadingCompanions
);

export const selectLoadingAcceptingCompanionRequest = createSelector(
  [getCompanionsState],
  (companions) => companions.loadingAcceptingCompanionRequest
);

export const selectLoadingRejectingCompanionRequest = createSelector(
  [getCompanionsState],
  (companions) => companions.loadingRejectingCompanionRequest
);

export const selectLoadingCompanionRequestById = (companionId: string) =>
  createSelector(
    [getCompanionsState],
    (companions) => companions.loadingCompanionRequestByCompanionId[companionId]
  );

export const selectLoadingCompanionsWidget = createSelector(
  [getCompanionsState],
  (companions) => companions.loadingCompanionsWidget
);

export const selectCompanionsInTheRoomCount = createSelector(
  [getCompanionsState],
  (companions) => companions.numberOfCompanionsInTheRoom
);
